import { Component, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { Subject, firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { UploadFileComponent } from 'src/app/components/upload-file/upload-file.component';
export interface PendingFileInfo {
  name: string;
  size: string;
  mimeType?: string;
}

@Component({
  selector: 'app-course-request-attachments',
  templateUrl: './course-request-attachments.component.html',
  styleUrls: ['./course-request-attachments.component.scss'],
})
export class CourseRequestAttachmentsComponent {
  @Input() courseItemId!: number;
  courseId: number | null = null;
  pendingDocuments: PendingFileInfo[] = [];

  @ViewChild('uploader', { static: false }) uploader!: UploadFileComponent;

  private uploadComplete$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  getPendingDocuments(): PendingFileInfo[] {
    if (!this.uploader) {
      return [];
    }

    const files = this.uploader.getSelectedFiles?.() || [];
    return files.map((file: File) => ({
      name: file.name,
      size: `${Math.round(file.size / 1024)} KB`,
      mimeType: file.type,
    }));
  }

  setCourseIdsFromData(data: any): void {
    let courseItemData = null;
    
    if (data?.CourseItems) {
      if (Array.isArray(data.CourseItems) && data.CourseItems.length > 0) {
        courseItemData = data.CourseItems[0];
      } else if (typeof data.CourseItems === 'object') {
        courseItemData = data.CourseItems;
      }
    }

    const itemId = Number(
      courseItemData?.id ?? 
      data?.courseItemId ?? 
      data?.course_item_id
    ) || null;

    // Extract course ID
    const cId = Number(
      courseItemData?.courseId ?? 
      data?.courseId ?? 
      data?.course_id
    ) || null;

    this.courseItemId = itemId;
    this.courseId = cId;

    if (this.uploader) {
      (this.uploader as any).courseItemId = this.courseItemId;
      (this.uploader as any).Id = this.courseId;
    }
    this.cdr.detectChanges();
  }

  async uploadFilesForCourse(courseItemId?: number): Promise<void> {
    if (courseItemId !== undefined && courseItemId !== null) {
      this.courseItemId = Number(courseItemId);
      if (this.uploader) {
        (this.uploader as any).courseItemId = this.courseItemId;
      }
      this.cdr.detectChanges();
    }

    const completion = firstValueFrom(this.uploadComplete$.pipe(take(1)));

    if (typeof (this.uploader as any).triggerUpload === 'function') {
      (this.uploader as any).triggerUpload();
    } else if (typeof (this.uploader as any).startUpload === 'function') {
      (this.uploader as any).startUpload(new MouseEvent('click'));
    } else if (typeof (this.uploader as any).startUploadProgrammatically === 'function') {
      (this.uploader as any).startUploadProgrammatically();
    } else {
      return;
    }

    await completion;
  }

  onChildUploadComplete(): void {
    this.uploadComplete$.next();
  }
}